import React from "react";
import "../styles/Footer.css";
import logo from "../assets/images_processed.jpeg";

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Logo and Slogan Section */}
                <div className="footer-section">
                    <img
                        src={logo} alt="Sol Cafe & Lounge"
                        className="footer-logo"
                    />
                    <p>Elevate your senses, embrace the extraordinary</p>
                    <div className="social-icons">
                        <a href="https://facebook.com" target="_blank" rel="noreferrer">
                            <i className="fab fa-facebook-f"></i>
                        </a>
                        <a href="https://instagram.com" target="_blank" rel="noreferrer">
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href="https://whatsapp.com" target="_blank" rel="noreferrer">
                            <i className="fab fa-whatsapp"></i>
                        </a>
                        <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                            <i className="fab fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                {/* Links Section */}
                <div className="footer-section">
                    <h4>UseFul Links</h4>
                    <ul>
                        <li>
                            <a href="/menu">Our Menu</a>
                        </li>
                        <li>
                            <a href="/reserve">Booking Table</a>
                        </li>
                        <li>
                            <a href="/events">Our Events</a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/sol_cafe.lounge/?hl=en">Our Instagram</a>
                        </li>
                    </ul>
                </div>

                {/* Contact Section */}
                <div className="footer-section">
                    <h4>Contact Us</h4>
                    <ul>
                        <li>
                            <i className="fas fa-phone"></i> +1 (647) 505-9020
                        </li>

                        <li>
                            <i className="fas fa-map-marker-alt"></i> 8206 Bayview Ave, Thornhill, ON L3T 2S2
                        </li>
                    </ul>
                </div>

                {/* Opening Hours Section */}
                <div className="footer-section">
                    <h4>Opening Hours</h4>
                    <ul>
                        <li>Tue - Thu: 6pm - 12am</li>
                        <li>Fri - Sat: 8:30pm - 2am</li>
                        <li>Sun: 6pm - 12am</li>
                    </ul>
                </div>
            </div>

            {/* Footer Bottom Section */}
            <div className="footer-bottom">
                <p>© 2025 Sol Cafe & Lounge. All Rights Reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;
